var _this = this;
import * as tslib_1 from "tslib";
import { createGroupMailTableQuery } from 'owa-group-mail-list-actions';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { readingPaneStore } from 'owa-mail-reading-pane-store';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import { onListViewTypeOptionSaved } from 'owa-options-actions/lib/onListViewTypeOptionSaved';
import { orchestrator } from 'satcheljs';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { ARCHIVE_FOLDERS_TREE_TYPE, SHARED_FOLDERS_TREE_TYPE } from 'owa-folders';
export default orchestrator(onListViewTypeOptionSaved, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var newListViewType, currentTableQuery, selectedFolder, selectedFolderTreeType, newTableQuery;
    return tslib_1.__generator(this, function (_a) {
        newListViewType = actionMessage.newListViewType;
        currentTableQuery = getSelectedTableView().tableQuery;
        selectedFolder = getSelectedFolder();
        selectedFolderTreeType = selectedFolder && selectedFolder.treeType;
        if (currentTableQuery.type === 1 /* Search */ ||
            selectedFolderTreeType === ARCHIVE_FOLDERS_TREE_TYPE ||
            selectedFolderTreeType === SHARED_FOLDERS_TREE_TYPE) {
            // Do not reload the Archive mailbox, Shared folder or search table when switching the listViewType options
            return [2 /*return*/];
        }
        if (currentTableQuery.type === 2 /* Group */) {
            newTableQuery = createGroupMailTableQuery(currentTableQuery.folderId, newListViewType);
        }
        else {
            newTableQuery = createMailFolderTableQuery(currentTableQuery.folderId, newListViewType, currentTableQuery.scenarioType, currentTableQuery.focusedViewFilter, currentTableQuery.viewFilter, currentTableQuery.categoryName);
        }
        loadTableViewFromTableQuery(newTableQuery);
        // Cleanup the reading pane state based on the old listViewType
        switch (newListViewType) {
            case 0 /* Conversation */:
                readingPaneStore.itemReadingPaneViewState = null;
                break;
            case 1 /* Message */:
                readingPaneStore.conversationReadingPaneViewState = null;
                break;
        }
        return [2 /*return*/];
    });
}); });
export { ReactListViewType };
//# sourceMappingURL=onListViewTypeOptionSavedOrchestrator.js.map